/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type EmailReceiverRequest = {
    email?: string;
    receiverType?: EmailReceiverRequest.receiverType;
    departmentCode?: number;
    valid?: boolean;
};
export namespace EmailReceiverRequest {
    export enum receiverType {
        NEARBY_STORE = 'NEARBY_STORE',
        DISSOCIATED = 'DISSOCIATED',
        BELOW_COST = 'BELOW_COST',
        REQUEST_APPLY_COMPETITOR_STORE = 'REQUEST_APPLY_COMPETITOR_STORE',
    }
}

